export const SOCKET_EVENT_TYPE = {
  REDUX: 1,
  SOCKET: 2,
};
